// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "./images/beminimalist.gif",
    title: "Beminimalist-Clone",
    description: "A web application that sells effective skin care products.",
    tech_stack: "Express | node.js | MongoDB | Mongoose | Ejs | JavaScript",
    github_url: "https://github.com/avishmonga/Beminimalist-Clone-website",
    demo_url: "https://beminimalist-clone-website.herokuapp.com/",
  },
  {
    img: "./images/plumgoodness.gif",
    title: "Plumgoodness-Clone",
    description: "A web application that sells SLS-Free skin care products.",
    tech_stack: "HTML | CSS | JavaScript | LocalStorage",
    github_url: "https://github.com/avishmonga/Clone-of-plumgoodness.com",
    demo_url: "https://plumgoodness-clone.netlify.app/",
  },
  {
    img: "https://user-images.githubusercontent.com/80064807/160084660-8b094066-8abf-4ecc-8a27-9dfac110ce38.gif",
    title: "Aha-Clone",
    description: "An Online Streaming Platform for Telugu & Tamil Movies.",
    tech_stack: "REACT | REDUX | JavaScript | JSX | FIREBASE ",
    github_url: "https://github.com/avishmonga/aha-clone",
    demo_url: "https://aha-clone.netlify.app/",
  },

  
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/mongodb.svg",
    name: "MongoDB",
  },
  {
    img: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/expressjs.svg",
    name: "Express",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/node-js.svg",
    name: "Node.js",
  },
  {
    img: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/npm.svg",
    name: "NPM",
  },
  {
    img: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/redux.svg",
    name: "Redux",
  },
  {
    img: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/postman.svg",
    name: "Postman",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
    {
      img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
      name: "HTML",
    },
    {
      img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
      name: "CSS",
    },
    {
      img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
      name: "JavaScript",
    },
];
